import { createPromiseAction } from 'redux-saga-promise-actions';

import { City, GetCitiesPayload } from 'store/types/cities';

export const getCities = createPromiseAction('GET_CITIES', 'GET_CITIES_SUCCEEDED', 'GET_CITIES_FAILURE')<
  GetCitiesPayload,
  { cities: City[] },
  undefined
>();
